import { ActionIcon, AppShell, Loader, Select, Title } from "@mantine/core";
import { WarningIcon } from "@phosphor-icons/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { HeaderTabs } from "@/features/dashboard/_components/Header";
import { SelectedCompanyContext, SelectedCompanyProvider } from "@/features/dashboard/configuracoes/_context/SelectedCompanyContext";
import { Role, useGetCompaniesQuery } from "@/store";
import { transformInOptions } from "@/utils";
import { requireRoles } from "@/utils/requiredRoles";

export const Route = createFileRoute("/_private/dashboard/_settings")({
  component: RouteComponent,
  beforeLoad: requireRoles({
    allowed: [Role.Administrador]
  })
});

enum MenuItem {
  SYSTEM = "Sistema",
  DELAY = "Avisos",
  INFORMATION = "Informações",
  BLOCKS = "Bloqueios",
  TERMS = "Termos",
  POPUPS = "Pop-ups"
  // NOTIFICATIONS = "Notificações",
  // INTEGRATIONS = "Integrações",
  // API = "API"
}

function RouteComponent() {
  const { data, isLoading } = useGetCompaniesQuery(undefined, {
    selectFromResult: (state) => {
      return {
        ...state,
        data: transformInOptions(state.data)
      };
    }
  });

  return (
    <SelectedCompanyProvider>
      <SelectedCompanyContext.Consumer>
        {({ companyId, setCompanyId }) => (
          <>
            <AppShell.Header>
              <HeaderTabs
                items={[
                  { children: MenuItem.SYSTEM, to: "/dashboard/configuracoes" },
                  { children: MenuItem.DELAY, to: "/dashboard/configuracoes/avisos" },
                  { children: MenuItem.INFORMATION, to: "/dashboard/configuracoes/informacoes" },
                  { children: MenuItem.BLOCKS, to: "/dashboard/configuracoes/bloqueios" },
                  { children: MenuItem.TERMS, to: "/dashboard/configuracoes/termos" },
                  { children: MenuItem.POPUPS, to: "/dashboard/configuracoes/popups" }
                  // { children: MenuItem.NOTIFICATIONS, to: "/dashboard/configuracoes/notificacoes" },
                  // { children: MenuItem.INTEGRATIONS, to: "/dashboard/configuracoes/integracoes" },
                  // { children: MenuItem.API, to: "/dashboard/configuracoes/api" }
                ]}
                from="/dashboard/configuracoes"
                components={{
                  select: (
                    <Select placeholder="Selecione uma empresa" data={data} value={companyId} leftSection={isLoading && <Loader size="sm" />} onChange={setCompanyId} size="sm" />
                  )
                }}
              />
            </AppShell.Header>

            <AppShell.Main>
              {companyId && <Outlet />}
              {!companyId && (
                <div className="grid place-items-center gap-4">
                  <ActionIcon size={128} variant="light" color="yellow" radius="100%">
                    <WarningIcon size={64} />
                  </ActionIcon>

                  <Title order={1}>Selecione uma empresa para continuar!</Title>
                </div>
              )}
            </AppShell.Main>
          </>
        )}
      </SelectedCompanyContext.Consumer>
    </SelectedCompanyProvider>
  );
}
